import * as api from '../api'
import { useApiQuery } from '../useApiQuery'

export default function usePlayOnDemandCourse(uuid: string | null, showPreview: boolean) {
  return useApiQuery({
    queryKey: ['playCourse', uuid, showPreview],
    queryFn: async () => {
      if (!uuid) {
        return null
      }
      return await api.get(showPreview ? `on-demand-course/${uuid}/preview` : `on-demand-course/${uuid}/play`)
    },
  })
}
